// Engineer Review Queue — thin role wrapper.
import React from 'react';
import OrchestratorReviewQueuePage from './OrchestratorReviewQueuePage';
import { useBreadcrumbUpdater } from '@ciea.ai/smart-infra-navigation';

const EngineerReviewQueuePage: React.FC = () => {
  useBreadcrumbUpdater([{ path: '/engineering', breadcrumb: 'Engineering Review' }]);
  return <OrchestratorReviewQueuePage role="engineer" />;
};
export default EngineerReviewQueuePage;
